import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import {faCaretUp} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {TeacherContext} from 'teacher/context'
import References from './references'
import Expectation from './expectation'

const useStyles = makeStyles(styles)
const useAccordionStyles = makeStyles(accordionStyles)
const useAccordionSummaryStyles = makeStyles(accordionSummaryStyles)
const useAccordionDetailStyles = makeStyles(accordionDetailStyles)

export default function Standard (props) {
  const classes = useStyles()
  const accordionClasses = useAccordionStyles()
  const accordionSummaryClasses = useAccordionSummaryStyles()
  const accordionDetailClasses = useAccordionDetailStyles()
  const context = useContext(TeacherContext)
  const {translate} = context
  const {standard, withReferences} = props
  const disciplineLabel = standard.content.discipline ? ` - ${standard.content.discipline}` : undefined
  return (
    <Accordion classes={accordionClasses} defaultExpanded={true} >
      <AccordionSummary classes={accordionSummaryClasses} expandIcon={<FontAwesomeIcon icon={faCaretUp}/>} >
       <Box className={classes.standardLabel}>{standard.name}{disciplineLabel}</Box>
       <Box className={classes.description}>{standard.content.description}</Box>
        {/*
       <Box className={classes.references}>
        <References references={standard.references} withReferences={withReferences} />
       </Box>
       */}
      </AccordionSummary>
      <AccordionDetails classes={accordionDetailClasses} >
        <Box className={classes.expectationsLabel}>{translate('expectations-and-indicators')}</Box>
        <Box className={classes.expectations}>
          {standard.expectations.map(expectation => (<Expectation key={expectation.id} expectation={expectation} withReferences={withReferences} />))}
        </Box>
      </AccordionDetails>
  </Accordion>)
}

function accordionStyles() {
  return {
    root: {
      boxShadow: 'none',
    }
  }
}

function accordionSummaryStyles () {
  return {
    root: {
      backgroundColor: '#f4faf8',
      color: '#4a5760',
      fontSize: '12pt',
      display: 'flex',
    },
    content: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
}

function accordionDetailStyles() {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: 0
    }
  }
}

function styles () {
  return {
    header: {
      display: 'flex'
    },
    standardLabel: {
      flexGrow: 1,
      color: '#3f5250',
      fontSize: '13pt',
      fontWeight: 'bold'
    },
    expectationsLabel: {
      color: '#3f5250',
      fontSize: '12pt',
      fontWeight: 'bold',
      padding: 16
    },
    description: {
      padding: '8px 16px',
      color: '#444e57',
      fontSize: '12pt'
    }
  }
}
